import { withNamespaces } from "react-i18next";
import { Col, Row } from "reactstrap";
import GeoMap from "src/modules/3rd-party-management/components/geo-map";

const GeolocationOverview = ({ t, locations }) => {
    const {
        geolocationReference,
        farmGeolocationReference,
        slaughterGeolocationReference
    } = locations;

    return (
        <Row>
            <Col sm="12" className="mb-3">
                <strong className="d-block mb-2">
                    {t(
                        farmGeolocationReference ? 
                        'Breeding Farm Location' :
                        'Geolocation Polygon'
                    )}
                </strong>

                <GeoMap
                    preDefinedGeo={geolocationReference}
                    multiDraw={true}
                    readOnly={true}
                    styles={{
                        height: '300px'
                    }}
                />
            </Col>

            {farmGeolocationReference && (
                <Col sm="12" className="mb-3">
                    <strong className="d-block mb-2">
                        {t('Fattening Farm Location')}
                    </strong>

                    <GeoMap
                        preDefinedGeo={farmGeolocationReference}
                        multiDraw={true}
                        readOnly={true}
                        styles={{
                            height: '300px'
                        }}
                    />
                </Col>
            )}

            {slaughterGeolocationReference && (
                <Col sm="12" className="mb-3">
                    <strong className="d-block mb-2">
                        {t('Slaughterhouse Location')}
                    </strong>

                    <GeoMap
                        preDefinedGeo={slaughterGeolocationReference}
                        multiDraw={true}
                        readOnly={true}
                        styles={{
                            height: '300px'
                        }}
                    />
                </Col>
            )}
        </Row>
    )
}

export default withNamespaces()(
    GeolocationOverview
);